// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(45deg, #00BA73 0%, #4C1CD2 100%);
  background-blend-mode: overlay;
  position: relative;
  overflow: hidden;
}

.login-form {
  background: #ffffff;
  padding: 40px;
  width: 100%;
  max-width: 400px;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1;
}

.login-logo {
  text-align: center;
  margin-bottom: 32px;
}

.login-logo h1 {
  font-size: 1.8rem;
  font-weight: 700;
  color: #4C1CD2;
  margin: 0;
}

.login-logo p {
  font-size: 0.95rem;
  color: #6b7280;
  margin-top: 8px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  color: #333333;
  font-size: 14px;
  margin-bottom: 8px;
  font-weight: 500;
}

.form-group input {
  width: 100%;
  padding: 12px 16px;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  color: #1f2937;
  font-size: 15px;
  outline: none;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}

.form-group input::placeholder {
  color: #9ca3af;
}

.form-group input:focus {
  border-color: #4C1CD2;
  box-shadow: 0 0 0 3px rgba(76, 28, 210, 0.1);
}

.form-group input:disabled {
  background: #f3f4f6;
  cursor: not-allowed;
}

.remember-password {
  margin: 16px 0;
}

.toggle-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.toggle-input {
  display: none;
}

.toggle-slider {
  position: relative;
  width: 44px;
  height: 24px;
  background-color: #d1d5db;
  border-radius: 24px;
  transition: background-color 0.3s;
}

.toggle-slider::before {
  content: '';
  position: absolute;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: white;
  top: 3px;
  left: 3px;
  transition: transform 0.3s;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
}

.toggle-input:checked + .toggle-slider {
  background-color: #4C1CD2;
}

.toggle-input:checked + .toggle-slider::before {
  transform: translateX(20px);
}

.toggle-text {
  font-size: 0.9rem;
  color: #4b5563;
}

.btn-submit {
  width: 100%;
  padding: 14px;
  background: #4C1CD2;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 8px;
  transition: background-color 0.2s ease, transform 0.1s ease;
}

.btn-submit:hover {
  background: #3d17a8;
}

.btn-submit:active {
  transform: scale(0.98);
}

.btn-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.error-message {
  color: #dc2626;
  font-size: 14px;
  margin-top: 8px;
  margin-bottom: 8px;
  padding: 10px 12px;
  background: #fee2e2;
  border-radius: 6px;
  border-left: 3px solid #dc2626;
}
`, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4DAA4D;EAC5D,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC","sourcesContent":[".login-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(45deg, #00BA73 0%, #4C1CD2 100%);\n  background-blend-mode: overlay;\n  position: relative;\n  overflow: hidden;\n}\n\n.login-form {\n  background: #ffffff;\n  padding: 40px;\n  width: 100%;\n  max-width: 400px;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  position: relative;\n  z-index: 1;\n}\n\n.login-logo {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.login-logo h1 {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: #4C1CD2;\n  margin: 0;\n}\n\n.login-logo p {\n  font-size: 0.95rem;\n  color: #6b7280;\n  margin-top: 8px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  color: #333333;\n  font-size: 14px;\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 12px 16px;\n  background: #ffffff;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  color: #1f2937;\n  font-size: 15px;\n  outline: none;\n  transition: border-color 0.2s ease;\n  box-sizing: border-box;\n}\n\n.form-group input::placeholder {\n  color: #9ca3af;\n}\n\n.form-group input:focus {\n  border-color: #4C1CD2;\n  box-shadow: 0 0 0 3px rgba(76, 28, 210, 0.1);\n}\n\n.form-group input:disabled {\n  background: #f3f4f6;\n  cursor: not-allowed;\n}\n\n.remember-password {\n  margin: 16px 0;\n}\n\n.toggle-label {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  cursor: pointer;\n  user-select: none;\n}\n\n.toggle-input {\n  display: none;\n}\n\n.toggle-slider {\n  position: relative;\n  width: 44px;\n  height: 24px;\n  background-color: #d1d5db;\n  border-radius: 24px;\n  transition: background-color 0.3s;\n}\n\n.toggle-slider::before {\n  content: '';\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background-color: white;\n  top: 3px;\n  left: 3px;\n  transition: transform 0.3s;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.2);\n}\n\n.toggle-input:checked + .toggle-slider {\n  background-color: #4C1CD2;\n}\n\n.toggle-input:checked + .toggle-slider::before {\n  transform: translateX(20px);\n}\n\n.toggle-text {\n  font-size: 0.9rem;\n  color: #4b5563;\n}\n\n.btn-submit {\n  width: 100%;\n  padding: 14px;\n  background: #4C1CD2;\n  color: #ffffff;\n  border: none;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  margin-top: 8px;\n  transition: background-color 0.2s ease, transform 0.1s ease;\n}\n\n.btn-submit:hover {\n  background: #3d17a8;\n}\n\n.btn-submit:active {\n  transform: scale(0.98);\n}\n\n.btn-submit:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.error-message {\n  color: #dc2626;\n  font-size: 14px;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  padding: 10px 12px;\n  background: #fee2e2;\n  border-radius: 6px;\n  border-left: 3px solid #dc2626;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
